<template>
  <div class="mb-1">
    <v-toolbar dense class="primary" dark flat>
      Address History <v-spacer> </v-spacer>
    </v-toolbar>
    <v-card outlined text class="mb-0 mt-4">
      <v-card-text class="pb-0">
        If you have not been at your current address for 12 months or you are
        not paying rent at your current address please list a previous address
      </v-card-text>
      <div class="d-flex pa-3  justify-center">
        <v-btn @click="open()" outlined color="primary">
          Add Previous Address
        </v-btn>
      </div>
    </v-card>
    <v-list class="mt-4" v-if="address.length">
      <v-card outlined v-for="(item, key) in address" :key="key" class="mb-2">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.add1 }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.city + ", " + item.state + ", " + item.postalcode }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="remvoe(key)">
              <v-icon color="red">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-card>
    </v-list>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <v-card>
        <v-card-title>
          Create Previous Address
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form class="mt-5" ref="form" v-model="valid">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.add1"
                  outlined
                  :rules="rules"
                  label="Street Address"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.city"
                  outlined
                  :rules="rules"
                  label="City"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.state"
                  :rules="rules"
                  outlined
                  label="State"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.zipcode"
                  :rules="ziprules"
                  outlined
                  type="number"
                  label="Zip Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.type"
                  :rules="rules"
                  :items="types"
                  outlined
                  label="Rent / Own"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.payment"
                  :rules="rules"
                  outlined
                  label="Monthly Payment"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="form.moveIn"
                      :rules="rules"
                      label="Move In Date"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.moveIn"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.moveOut"
                      :rules="rules"
                      label="Move Out Date"
                      outlined
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.moveOut"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.managerName"
                  :rules="rules"
                  label="Landlord Name"
                  outlined
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.managerPhone"
                  type="number"
                  :rules="mobileRules"
                  label="Landlord Phone"
                  outlined
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn class="mr-5" @click="dialog = false" color="error" text
            >Cancel</v-btn
          >
          <v-btn class="mr-5" @click="submit()" color="success" text
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      form: {
        type: "",
        zipcode: "",
        add1: "",
        moveIn: "",
        moveOut: "",
        city: "",
        state: "",
        payment: "",
        managerPhone: "",
        managerName: "",
      },
      ans: "",
      dialog: false,
      valid: false,
      address: [],
      types: ["Rent", "Own"],
      min: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      rules: [(v) => !!v || "Field is required"],
      mobileRules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v.length <= 10) || "Phone can't be more then 10 digit",
      ],

      emailRules: [
        (v) => !!v || "Field is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      ziprules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v.length === 5) || "5 digit zip code required",
      ],
    };
  },
  watch: {
    address(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    open() {
      const vm = this;
      vm.form = {};
      vm.dialog = true;
    },
    remvoe(key) {
      let check = confirm("Are you sure?");
      if (!check) return;
      this.address.splice(key, 1);
    },
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      let form = {};
      for (let key in vm.form) {
        form[key] = vm.form[key];
      }
      vm.address.push(form);
      vm.$refs.form.reset();
      vm.dialog = false;
      vm.valid = false;
    },
  },
};
</script>

<style></style>
